import { render, staticRenderFns } from "./MMaterialRegister.vue?vue&type=template&id=d5a3d7a6&scoped=true&"
import script from "./MMaterialRegister.vue?vue&type=script&lang=ts&"
export * from "./MMaterialRegister.vue?vue&type=script&lang=ts&"
import style0 from "./MMaterialRegister.vue?vue&type=style&index=0&id=d5a3d7a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a3d7a6",
  null
  
)

export default component.exports